export enum assetFormFields {
  nameEn = 'nameEn',
  nameAr = 'nameAr',
  descriptionEn = 'descriptionEn',
  descriptionAr = 'descriptionAr',
}
